import "../../style.css";
import "../user-area.css";
import "./jedi.css";
import React, { useEffect, useState, useRef } from "react";
import { API_URL } from "../../../api";
import Cookies from "universal-cookie";

const Jedi = (data = { data }) => {
	const [full_menu_list, setFullMenuList] = useState([]);
	const [display_menu_list, setDisplayMenuList] = useState([]);
	const [SelectedWindow, setSelectedWindow] = useState("blacklist");
	const [PreviousWindow, setPreviousWindow] = useState("blacklist");
	const [mark_button_state, setMarkButtonState] = useState("mark");
	const [mark_button_text, setMarkButtonText] = useState("select_all");

	const [colorPallete] = useState([
		"1px solid white",
		"none",
	]);

	const [BgWhitelist, setBgWhitelist] = useState(colorPallete[1]);
	const [BgBlacklist, setBgBlacklist] = useState(colorPallete[0]);

	const cookies = new Cookies();
	const sessionToken = cookies.get("sessionToken");

	const [add_visible, setAddVisible] = useState("none");
	const SearchInput = useRef(null);

	const food_list = {
		blacklist: data.data.food_data.blacklist,
		whitelist: data.data.food_data.whitelist,
	};

	const [SelectedList, SetSelectedList] = useState({
		blacklist: food_list.blacklist,
		blacklist_selected: [],
		whitelist: food_list.whitelist,
		whitelist_selected: [],
	});

	useEffect(() => {
		fetch(API_URL + "/api/full_menu")
			.then((response) => response.json())
			.then((data) => {
				//convert data to set
				data["menuItems"] = new Set(data["menuItems"]);
				data["menuItems"] = [...data["menuItems"]];
				setFullMenuList(data["menuItems"]);
				setDisplayMenuList(data["menuItems"]);
			})
			.catch((error) => {
				console.log(error);
				setFullMenuList(["Error"]);
				setDisplayMenuList(["Error"]);
			});
	}, []);

	useEffect(() => {
		SearchInput.current.focus();
	}, [add_visible]);

	const handleClick = (event) => {
		const name = event.target.innerText;

		if (SelectedList.blacklist.includes(name)) {
			SetSelectedList({
				...SelectedList,
				blacklist: SelectedList.blacklist.filter(
					(item) => item !== name
				),
				blacklist_selected: [...SelectedList.blacklist_selected, name],
			});
		} else if (SelectedList.blacklist_selected.includes(name)) {
			SetSelectedList({
				...SelectedList,
				blacklist: [...SelectedList.blacklist, name],
				blacklist_selected: SelectedList.blacklist_selected.filter(
					(item) => item !== name
				),
			});
		} else if (SelectedList.whitelist.includes(name)) {
			SetSelectedList({
				...SelectedList,
				whitelist: SelectedList.whitelist.filter(
					(item) => item !== name
				),
				whitelist_selected: [...SelectedList.whitelist_selected, name],
			});
		} else if (SelectedList.whitelist_selected.includes(name)) {
			SetSelectedList({
				...SelectedList,
				whitelist: [...SelectedList.whitelist, name],
				whitelist_selected: SelectedList.whitelist_selected.filter(
					(item) => item !== name
				),
			});
		}
	};

	const handleChange = () => {
		const search = SearchInput.current.value;
		const filtered = full_menu_list.filter((item) => {
			return item.toLowerCase().includes(search.toLowerCase());
		});
		setDisplayMenuList(filtered);
	};

	const toggleAddMenu = () => {
		if (add_visible === "flex") {
			setAddVisible("none");
		} else {
			setAddVisible("flex");
		}
	};

	const addItem = (event) => {
		const name = event.target.innerText;

		if (SelectedWindow === "blacklist") {
			if (
				!SelectedList.blacklist.includes(name) &&
				!SelectedList.whitelist.includes(name)
			) {
				SetSelectedList({
					...SelectedList,
					blacklist: [...SelectedList.blacklist, name],
				});
			}
		} else if (SelectedWindow === "whitelist") {
			if (
				!SelectedList.whitelist.includes(name) &&
				!SelectedList.blacklist.includes(name)
			) {
				SetSelectedList({
					...SelectedList,
					whitelist: [...SelectedList.whitelist, name],
				});
			}
		}

		setAddVisible("none");
	};

	const deleteItem = () => {
		if (SelectedWindow === "blacklist") {
			SetSelectedList({
				...SelectedList,
				blacklist: SelectedList.blacklist.filter(
					(item) => !SelectedList.blacklist_selected.includes(item)
				),
				blacklist_selected: [],
			});
		} else if (SelectedWindow === "whitelist") {
			SetSelectedList({
				...SelectedList,
				whitelist: SelectedList.whitelist.filter(
					(item) => !SelectedList.whitelist_selected.includes(item)
				),
				whitelist_selected: [],
			});
		}
	};

	const HandleSelectedWindow = (window) => {
		return () => {
			setSelectedWindow(window);

			if (window === "blacklist") {
				setBgBlacklist(colorPallete[0]);
				setBgWhitelist(colorPallete[1]);
			} else if (window === "whitelist") {
				setBgBlacklist(colorPallete[1]);
				setBgWhitelist(colorPallete[0]);
			}

			if (window === "blacklist" && PreviousWindow === "whitelist") {
				setMarkButtonState("mark");
				setMarkButtonText("select_all");

				SetSelectedList({
					...SelectedList,
					whitelist: [
						...SelectedList.whitelist,
						...SelectedList.whitelist_selected,
					],
					whitelist_selected: [],
				});
			} else if (
				window === "whitelist" &&
				PreviousWindow === "blacklist"
			) {
				setMarkButtonState("mark");
				setMarkButtonText("select_all");
				SetSelectedList({
					...SelectedList,
					blacklist: [
						...SelectedList.blacklist,
						...SelectedList.blacklist_selected,
					],
					blacklist_selected: [],
				});
			}
			setPreviousWindow(window);
		};
	};

	const HandleMark = (action) => {
		return () => {
			if (action === "mark") {
				if (SelectedWindow === "blacklist") {
					SetSelectedList({
						...SelectedList,
						blacklist_selected: [
							...SelectedList.blacklist_selected,
							...SelectedList.blacklist,
						],
						blacklist: [],
					});
				} else if (SelectedWindow === "whitelist") {
					SetSelectedList({
						...SelectedList,
						whitelist_selected: [
							...SelectedList.whitelist_selected,
							...SelectedList.whitelist,
						],
						whitelist: [],
					});
				}
			} else if (action === "unmark") {
				if (SelectedWindow === "blacklist") {
					SetSelectedList({
						...SelectedList,
						blacklist: [
							...SelectedList.blacklist_selected,
							...SelectedList.blacklist,
						],
						blacklist_selected: [],
					});
				} else if (SelectedWindow === "whitelist") {
					SetSelectedList({
						...SelectedList,
						whitelist: [
							...SelectedList.whitelist_selected,
							...SelectedList.whitelist,
						],
						whitelist_selected: [],
					});
				}
			}
			setMarkButtonState((action) => {
				if (action === "mark") {
					return "unmark";
				} else if (action === "unmark") {
					return "mark";
				}
			});
			setMarkButtonText(action === "mark" ? "deselect" : "select_all");
		};
	};

	const HandleSave = () => {
		let data = {
			blacklist: [
				...SelectedList.blacklist,
				...SelectedList.blacklist_selected,
			],
			whitelist: [
				...SelectedList.whitelist,
				...SelectedList.whitelist_selected,
			],
		};
		data = JSON.stringify(data);

		fetch(
			`${API_URL}/api/menu_data_modification?token=${encodeURIComponent(
				sessionToken
			)}&menu_data=${data}&type=jedi`
		)
			.then((response) => response.json())
			.then((data) => {
				window.location.reload();
			})
			.catch((error) => {
				console.log(error);
			});
	};

	return (
		<div>
			<div className="container">
				<div id="toolbar">
					<button
						className="icon_btn cal"
						onClick={() => {
							window.location.href = "/kalibracija";
						}}>
						HITRA KALIBRACIJA
					</button>
					<button
						className="icon_btn"
						onClick={HandleMark(mark_button_state)}>
						<span className="material-symbols-outlined">
							{mark_button_text}
						</span>
					</button>
					<button className="icon_btn" onClick={toggleAddMenu}>
						<span className="material-symbols-outlined">
							add_box
						</span>
					</button>
					<button className="icon_btn" onClick={deleteItem}>
						<span className="material-symbols-outlined">
							delete
						</span>
					</button>
					<button onClick={HandleSave} className="icon_btn">
						<span className="material-symbols-outlined">
							save
						</span>
					</button>
				</div>
				<div
					id="blacklist"
					className="column"
					style={{ border: BgBlacklist }}
					onClick={HandleSelectedWindow("blacklist")}>
					<h2>Nezaželjeni obroki</h2>
					<ul>
						{SelectedList.blacklist_selected.map(
							(ime_menija, index) => (
								<li
									style={{ border: "1px solid white" }}
									key={index}
									className="food-item"
									onClick={(event) => {
										handleClick(event);
									}}>
									{ime_menija}
								</li>
							)
						)}
						{SelectedList.blacklist.map((ime_menija, index) => (
							<li
								key={index}
								className="food-item"
								onClick={(event) => {
									handleClick(event);
								}}>
								{ime_menija}
							</li>
						))}
					</ul>
				</div>
				<div
					id="whitelist"
					className="column"
					style={{ border: BgWhitelist }}
					onClick={HandleSelectedWindow("whitelist")}>
					<h2>Zaželjeni obroki</h2>
					<ul>
						{SelectedList.whitelist_selected.map(
							(ime_menija, index) => (
								<li
									style={{ border: "1px solid white" }}
									key={index}
									className="food-item"
									onClick={(event) => {
										handleClick(event);
									}}>
									{ime_menija}
								</li>
							)
						)}
						{SelectedList.whitelist.map((ime_menija, index) => (
							<li
								key={index}
								className="food-item"
								onClick={(event) => {
									handleClick(event);
								}}>
								{ime_menija}
							</li>
						))}
					</ul>
				</div>
			</div>
			<div className="wholePopup" style={{ display: add_visible }}>
				<div className="popup" id="popup">
					<div className="popup-header">
						<input
							autoComplete="off"
							type="text"
							placeholder="Išči"
							ref={SearchInput}
							onChange={handleChange}
						/>
						<span className="close" onClick={toggleAddMenu}>
							&times;
						</span>
					</div>
					<div className="popup-body">
						<ul id="display">
							{display_menu_list.map((ime_menija) => (
								<li
									key={ime_menija}
									onClick={(event) => {
										addItem(event);
									}}>
									{ime_menija}
								</li>
							))}
						</ul>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Jedi;
